export function normalizarCPF(cpf: string): string {
    return (cpf || '').replace(/\D/g, '');
}

export function validarCPF(cpf: string): boolean {
    const numeros = normalizarCPF(cpf);

    if (numeros.length !== 11) {
        return false;
    }

    if (/^(\d)\1{10}$/.test(numeros)) {
        return false;
    }

    const calcularDigito = (base: string, pesoInicial: number): number => {
        let soma = 0;
        for (let i = 0; i < base.length; i++) {
            soma += parseInt(base.charAt(i), 10) * (pesoInicial - i);
        }
        const resto = (soma * 10) % 11;
        return resto === 10 ? 0 : resto;
    };

    const primeiroDigito = calcularDigito(numeros.substring(0, 9), 10);
    if (primeiroDigito !== parseInt(numeros.charAt(9), 10)) {
        return false;
    }

    const segundoDigito = calcularDigito(numeros.substring(0, 10), 11);
    if (segundoDigito !== parseInt(numeros.charAt(10), 10)) {
        return false;
    }

    return true;
}
